import React, { useContext, useRef, useState } from 'react'
import ConfirmDialog from '../../../../components/dialogs/ConfirmDialog'
import ErrorDialog from '../../../../components/dialogs/ErrorDialog'
import OnScreenAssist from '../../../../components/ui/hint/OnScreenAssist'
import ToDoListService from '../../../../libs/api/services/ToDoListService'
// import { ToDoListAdminProvider } from './ToDoListAdminProvider'
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'
import TitleBarComponent from './Components/TitleBarComponent'
import ToDoListOverview from './Components/ToDoListOverview'
import './ToDoListAdmin.css'

export const ToDoListAdminContext = React.createContext()

const ToDoListAdminProvider = ({ children }) => {
    const [state, setState] = useState({
        ToDoLists: [],
        ToDoList: undefined,
        ToDoListItem: undefined,
        ToDoListItemStatuses: [],
        ToDoListValidation: [],
        focus: {
            group: undefined,
            item: undefined,
            status: undefined,
            properties: undefined,
        }
    })
    const [delOpt, setDelOpt] = useState({ onCancel: () => { }, onConfirm: () => { }, title: undefined, open: false, text: '' })
    const [error, setError] = useState({
        error: undefined, onClose: () => setError({
            ...error, error: undefined
        }), humanize: true
    })


    /**
     * To Do List
     */
    const _validateAll = (_ToDoLists) => {
        var res = []
        LI: for (const td of _ToDoLists) {
            const list = td

            if (!list.resource) { res[list.resource.resource.id] = "There are no items on this to do list"; continue; }
            if (!list.resources) { res[list.resource.resource.id] = "There are no items on this to do list"; continue; }
            if (list.resources.length === 0) { res[list.resource.resource.id] = "There are no items on this to do list"; continue; }
            for (const l of list.resources) {
                if (!l.resources || l.resources.length === 0) {
                    res[list.resource.resource.id] = "Not all items have statuses set"; continue LI;
                }
                var _hasCloseStatus = false
                var _hasdefaultstatus = false
                for (const i of l.resources) {
                    if (i.resource.isDefault) _hasdefaultstatus = true
                    if (i.resource.properties) {
                        if (i.resource.properties.find(p => p.property === "REMOVE_ON_SELECTED") && i.resource.properties.find(p => p.property === "REMOVE_ON_SELECTED").value === "true")
                            _hasCloseStatus = true
                    }
                }
                if (!_hasdefaultstatus) {
                    res[list.resource.resource.id] = `${l.resource.resource.list} does not have a default status set`; continue LI;
                }
                if (!_hasCloseStatus) {
                    res[list.resource.resource.id] = `${l.resource.resource.list} does not have a status with a remove from list option set`; continue LI;
                }
            }
            res[list.resource.resource.id] = undefined
        }
        return res
    }

    const validateToDoList = (ToDoListID) => {
        try {
            return state.ToDoListValidation[ToDoListID]
        } catch (e) {
            return undefined
        }
    }


    const loadToDoLists = async () => {
        // Get From API
        const _ToDoLists = await ToDoListService.ListToDoLists().catch((e) => setError({ ...error, error: e }))
        var list = []
        // for (const _list of _ToDoLists)
        //     if (hasAccess(_list)) list.push(_list)
        // console.log('loadToDoLists', list)
        // Store to local memeory
        if (!_ToDoLists) return
        setState({
            ...state,
            ToDoLists: _ToDoLists,
            ToDoListItems: [],
            ToDoListValidation: _validateAll(_ToDoLists)
        })
        // return to requester
        return _ToDoLists
    }
    const addToDoLists = async (v) => {
        // await new Promise((resolve) => setTimeout(resolve, 5000));
        const new_list = {
            resource: {
                resource: await ToDoListService.CreateToDoList({
                    group: v
                }).catch((e) => setError({ ...error, error: e }))
            }
        }

        if (new_list) setState({
            ...state,
            ToDoLists: [...state.ToDoLists, new_list],
            ToDoList: new_list,
            ToDoListValidation: _validateAll([...state.ToDoLists, new_list]),
            focus: { group: new_list.id }
        })

    }

    const cloneToDoList = async (v) => {
        // await new Promise((resolve) => setTimeout(resolve, 5000));

        const new_list = {
            resource: {
                resource: await ToDoListService.cloneToDoList(v).catch((e) => setError({ ...error, error: e }))
            }
        }
        if (new_list) setState({
            ...state,
            ToDoLists: [...state.ToDoLists, new_list],
            ToDoList: new_list,
            ToDoListValidation: _validateAll([...state.ToDoLists, new_list]),
            focus: { group: new_list.id }
        })

    }

    const setActiveList = (list) => {
        setState({
            ...state,
            ToDoList: list
        })
    }
    const removeToDoList = async (toDoList, confirmed) => {
        if (!confirmed) {
            setDelOpt({
                title: "Remove List", open: true, onCancel: () => setDelOpt(), onConfirm: () => { removeToDoList(toDoList, true); setDelOpt() },
                text: 'Are you sure you would like to remove this to do list?'
            })
        }
        else if (confirmed) {
            ToDoListService.RemoveToDoList(toDoList.id)
                .then((r) => {
                    setState({
                        ...state,
                        ToDoList: undefined,
                        ToDoLists: state.ToDoLists.filter((l) => l.resource.resource.id !== toDoList.id),
                        ToDoListValidation: _validateAll(state.ToDoLists.filter((l) => l.id !== toDoList.id))

                    })
                }).catch((e) => setError({ ...error, error: e }))
        }
    }
    const renameToDoList = async (toDoList, name, confirmed) => {
        if (!confirmed) {
            setDelOpt({
                title: "Rename List", open: true, onCancel: () => setDelOpt(), onConfirm: async () => { await renameToDoList(toDoList, name, true); setDelOpt() },
                text: `Are you sure you would like to rename this to do list to ${name}?`
            })
        }
        else if (confirmed) {
            return await ToDoListService.renameToDoList(toDoList.id, { ...toDoList, group: name })
                .then((r) => {
                    var _list = state.ToDoLists.find((l) => l.resource.resource.id === toDoList.id)
                    _list.resource.resource.group = name
                    setState({
                        ...state,
                        // ToDoList: undefined,
                        ToDoLists: [...state.ToDoLists],
                        ToDoListValidation: _validateAll(state.ToDoLists)
                    })
                }).catch((e) => setError({ ...error, error: e }))
        }
    }
    /**
     * To Do List Items
     */
    const loadToDoListItems = async (toDoList) => {
        try {
            const lists = state.ToDoLists.find((l) => l.id === toDoList.id).lists
            setState({
                ...state,
                ToDoListItems: lists ? lists : [],
                ToDoListItem: undefined,
                ToDoListItemStatuses: [],
                ToDoListValidation: _validateAll(state.ToDoLists)
            })
            return lists
        } catch (e) { return [] }
    }
    const addToDoListItem = async (toDoList, item) => {
        // const lists = state.ToDoLists
        // var list = lists.find((l) => l.resource.resource.id === toDoList.id)
        // console.log(list, lists[lists.indexOf(list)].resources)
        // lists[lists.indexOf(list)].lists
        const new_item = {
            resource: {
                resource: await ToDoListService.UpsertToDoListItem(toDoList.id, {
                    list: item
                }).catch((e) => setError({ ...error, error: e }))
            }
        }

        if (new_item) {
            const lists = state.ToDoLists
            var list = lists.find((l) => l.resource.resource.id === toDoList.id)
            // console.log(list, lists[lists.indexOf(list)])
            if (list && lists[lists.indexOf(list)].resources)
                lists[lists.indexOf(list)].resources = [...lists[lists.indexOf(list)].resources, new_item]
            else
                lists[lists.indexOf(list)].resources = [new_item]

            setState({
                ...state,
                ToDoLists: lists,
                ToDoListItem: new_item,
                ToDoListItems: lists[lists.indexOf(list)].resources,
                ToDoListValidation: _validateAll(state.ToDoLists)
            })
        }
    }
    const cloneToDoListItem = async (toDoListID, itemId, name) => {
        const new_item = {
            resource: {
                resource: await ToDoListService.CloneToDoListItem(toDoListID, itemId, name).catch((e) => setError({ ...error, error: e }))
            }
        }
        if (new_item) {
            const lists = state.ToDoLists
            var list = lists.find((l) => l.resource.resource.id === toDoListID)

            if (list && lists[lists.indexOf(list)].resources)
                lists[lists.indexOf(list)].resources = [...lists[lists.indexOf(list)].resources, new_item]
            else
                lists[lists.indexOf(list)].resources = [new_item]

            setState({
                ...state,
                ToDoLists: lists,
                ToDoListItem: new_item,
                ToDoListItems: lists[lists.indexOf(list)].resources,
                ToDoListValidation: _validateAll(state.ToDoLists)
            })
        }
    }
    const cloneToDoListItemArray = async (toDoListID, itemId, names) => {
        const lists = state.ToDoLists
        for (const name of names) {
            const new_item = {
                resource: {
                    resource: await ToDoListService.CloneToDoListItem(toDoListID, itemId, name).catch((e) => setError({ ...error, error: e }))
                }
            }
            if (new_item) {

                var list = lists.find((l) => l.resource.resource.id === toDoListID)
                if (list && lists[lists.indexOf(list)].resources)
                    lists[lists.indexOf(list)].resources = [...lists[lists.indexOf(list)].resources, new_item]
                else
                    lists[lists.indexOf(list)].resources = [new_item]
            }
        }
        setState({
            ...state,
            ToDoLists: lists,
            // ToDoListItem: new_item,
            ToDoListItems: lists[lists.indexOf(list)].resources,
            ToDoListValidation: _validateAll(state.ToDoLists)
        })

    }
    const setActiveToDoListItem = (item) => {
        setState({
            ...state,
            ToDoListItem: item ? item : undefined
        })
    }

    const removeToDoListItem = async (ToDoList, toDoListItem, confirmed) => {

        if (!confirmed) {
            setDelOpt({
                title: "Remove Item", open: true, onCancel: () => setDelOpt(), onConfirm: () => { removeToDoListItem(ToDoList, toDoListItem, true); setDelOpt() },
                text: 'Are you sure you would like to remove this to do list item?'
            })
        }
        else if (confirmed) {
            const lists = state.ToDoLists
            var list = lists.find((l) => l.resource.resource.id === ToDoList.id)
            lists[lists.indexOf(list)].resources = lists[lists.indexOf(list)].resources.filter((f) => f.resource.resource.id !== toDoListItem.resource.id)
            ToDoListService.RemoveToDoListItem(toDoListItem.resource.id)
                .then((r) => {
                    setState({
                        ...state,
                        ToDoLists: lists,
                        ToDoListItems: lists[lists.indexOf(list)].resources,
                        ToDoListItem: undefined,
                        ToDoListItemStatuses: [],
                        ToDoListValidation: _validateAll(lists)
                    })
                }).catch((e) => setError({ ...error, error: e }))
        }
    }

    const renameToDoListItem = async (ToDoList, toDoListItem, name, confirmed) => {

        if (!confirmed) {
            setDelOpt({
                title: "Remove Item", open: true, onCancel: () => setDelOpt(), onConfirm: () => { renameToDoListItem(ToDoList, toDoListItem, name, true); setDelOpt() },
                text: `Are you sure you would like to rename this to do list item to ${name}?`
            })
        }
        else if (confirmed) {
            const r = await ToDoListService.RenameToDoListItem(ToDoList.id, { ...toDoListItem.resource, list: name })
                .catch((e) => setError({ ...error, error: e }))

            if (r) {
                var lists = state.ToDoLists

                var list = lists.find((l) => l.resource.resource.id === ToDoList.id)
                lists[lists.indexOf(list)].resources.find((f) => f.resource.resource.id === toDoListItem.resource.id).resource.resource.list = name

                setState({
                    ...state,
                    ToDoLists: lists,
                    ToDoListItems: lists[lists.indexOf(list)].resources,
                    ToDoListItem: undefined,
                    ToDoListItemStatuses: [],
                    ToDoListValidation: _validateAll(lists)
                })
            }
        }
    }

    /**
     * To Do List Statuses
     */
    const loadToDoListItemStatuses = (toDoList, toDoListItem) => {
        try {
            const lists = state.ToDoLists.find((l) => l.id === toDoList.id).lists.find((i) => i.id === toDoListItem.id).items
            setState({
                ...state,
                ToDoListItemStatuses: lists ? lists : [],
                ToDoListValidation: _validateAll(state.ToDoLists)
            })
            return lists
        } catch (e) { return [] }
    }

    const addToDoListItemStatus = async (Group, toDoListItem, status) => {
        const new_item = {
            resource: await ToDoListService.UpsertToDoListItemStatus(toDoListItem.id, {
                item: status
            }).catch((e) => setError({ ...error, error: e }))
        }

        if (new_item) {
            var items = state.ToDoLists.find((i) => i.resource.resource.id === Group.id).resources
                .find((i) => i.resource.resource.id === toDoListItem.id)
                .resources

            if (items)
                items.push(new_item)
            else
                items = state.ToDoLists.find((i) => i.resource.resource.id === Group.id).resources
                    .find((i) => i.resource.resource.id === toDoListItem.id).resources = [new_item]
            setState({
                ...state,
                ToDoListValidation: _validateAll(state.ToDoLists)
            })
        }
    }

    const RemoveStatus = async (Group, ActiveToDoListItem, statusId, confirmed) => {

        if (!confirmed) {
            setDelOpt({
                title: "Remove Status", open: true, onCancel: () => setDelOpt(), onConfirm: () => { RemoveStatus(Group, ActiveToDoListItem, statusId, true); setDelOpt() },
                text: 'Are you sure you would like to remove this status?'
            })
        } else if (confirmed) {

            await ToDoListService
                .RemoveToDoListStatus(ActiveToDoListItem.id, statusId)
                .then(async (r) => {

                    var items = state.ToDoLists.find((i) => i.resource.resource.id === Group.id).resources
                        .find((i) => i.resource.resource.id === ActiveToDoListItem.id)
                        .resources
                    const _item = items.find((s) => s.resource.id === statusId)
                    items.splice(items.indexOf(_item), 1)

                    setState({
                        ...state,
                        ToDoListValidation: _validateAll(state.ToDoLists)
                    })
                }).catch((e) => setError({ ...error, error: e }))
        }
    }

    const RenameStatus = async (Group, ActiveToDoListItem, statusId, name, confirmed) => {
        if (!confirmed) {
            setDelOpt({
                title: "Remove Item", open: true, onCancel: () => setDelOpt(), onConfirm: () => { RenameStatus(Group, ActiveToDoListItem, statusId, name, true); setDelOpt() },
                text: `Are you sure you would like to rename this to do list item to ${name}?`
            })
        }
        else if (confirmed) {
            var item = state.ToDoLists.find((i) => i.resource.resource.id === Group.id).resources
                .find((i) => i.resource.resource.id === ActiveToDoListItem.id)
                .resources.find((s) => s.resource.id === statusId.id)

            item.resource.item = name

            await ToDoListService.RenameToDoListStatus(ActiveToDoListItem.id, { ...item, item: name })
                .then((r) => {
                    setState({
                        ...state,
                        ToDoListValidation: _validateAll(state.ToDoLists)
                    })
                }).catch((e) => setError({ ...error, error: e }))
        }
    }
    const setToDoListItemDefaultStatus = async (Group, list, status) => {
        var lists = state.ToDoLists
        var activeList = lists.find((l) => l.resource.resource.id === Group.id)

        // console.log('setToDoListItemDefaultStatus', lists[lists.indexOf(activeList)].resources.find((f) => f.resource.resource.id === list.id))
        var items = lists[lists.indexOf(activeList)].resources.find((f) => f.resource.resource.id === list.id).resources

        // console.log('setToDoListItemDefaultStatus', items)
        // .find(x => x.id === statusId.id)
        items.map(x => {
            x.resource.id !== status.id ? x.resource.isDefault = false : x.resource.isDefault = true
            return x
        })

        ToDoListService.setToDoListItemDefaultStatus(status.id)
            .then((r) =>
                setState({
                    ...state,
                    ToDoListValidation: _validateAll(state.ToDoLists)
                })
            ).catch((e) => { })
    }
    const SetStatusProperty = async (ItemId, Key, Value) => {
        if (!(ItemId, Key && Value)) return
        ToDoListService
            .SetStatusProperty(ItemId, {
                property: Key,
                value: Value
            }).then((r) => {
                loadToDoLists()
                // setState({
                //     ...state,
                //     ToDoListValidation: _validateAll(state.ToDoLists)
                // })
            })

    }

    return (<ToDoListAdminContext.Provider value={{
        /* Lists */
        validateToDoList,
        loadToDoLists,
        setActiveList,
        ToDoLists: state.ToDoLists,
        ActiveList: state.ToDoList,
        addToDoLists,
        cloneToDoList,
        removeToDoList,
        renameToDoList,
        /* Items */
        loadToDoListItems,
        ToDoListItems: state.ToDoListItems,
        addToDoListItem,
        cloneToDoListItem,
        cloneToDoListItemArray,
        setActiveToDoListItem,
        ActiveToDoListItem: state.ToDoListItem,
        removeToDoListItem,
        renameToDoListItem,
        setToDoListItemDefaultStatus,
        /* Statuses */
        loadToDoListItemStatuses,
        ToDoListItemStatuses: state.ToDoListItemStatuses,
        addToDoListItemStatus,
        RemoveStatus,
        RenameStatus,
        SetStatusProperty,
        focus: state.focus,
        setFocus: (id) => setState({ ...state, focus: id })
    }}>
        <ConfirmDialog {...delOpt}>
            {delOpt && delOpt.text && <div>{delOpt.text}</div>}
        </ConfirmDialog>
        <ErrorDialog {...error} />
        {children}
    </ToDoListAdminContext.Provider>)
}

export default function ToDoListAdmin() {
    const [mode, setMode] = useState('overview')
    return (
        <ToDoListAdminProvider>
            <div className="m-3 mh-100 flex-grow-1 d-flex flex-column">
                <h1 className="text-center">To Do List Management</h1>
                {
                    mode === 'overview'
                        ?
                        <ToDoListOverview />
                        :
                        <>
                            {/* <ToDoListGroups />
                        <ToDoListItems>
                            <ToDoListStatus />
                        </ToDoListItems> */}
                        </>
                }
            </div>
            <OnScreenAssist key={'osa-to-do-list'} items={[
                {
                    heading: 'What is a to do list',
                    description: 'A to do list comprises of a list of items to complete. These items are normaly taks to be completed for the list'
                }, {
                    heading: 'What is a list item',
                    description: 'A list item is an item / task that needs to be carried out or checked off'
                }, {
                    heading: 'What is a list item status',
                    description: 'This is a particular status an item can be in at any given time'
                }
            ]} />
        </ToDoListAdminProvider>
    )
}


/*
Components
*/


const ToDoListItemsLineItem = ({ group, list, children, onRemove, onEdit }) => {
    const { showConfirm, showError } = useContext(CommonFunctionsContext)
    const { cloneToDoListItem, cloneToDoListItemArray } = useContext(ToDoListAdminContext)
    const CloneNameRef = useRef()
    const CloneBulkRef = useRef()

    const _handleClone = async (e) => {
        if (e) {
            e.stopPropagation()
        }
        showConfirm({
            layout: 'beeeg',
            onCancel: () => { },
            onConfirm: (a) => {
                if (CloneBulkRef.current.value && CloneBulkRef.current.value !== "") {
                    const split = CloneBulkRef.current.value.split("\n")
                        .map(itemName => itemName.trim())
                    cloneToDoListItemArray(
                        group.id,
                        list.resource.id,
                        split
                    )
                        .then(res => { return true })
                        .catch(err => showError(err))
                }
                else {
                    if (!CloneNameRef.current.value || CloneNameRef.current.value === '') {
                        CloneNameRef.current.placeholder = 'Please enter a name to clone to'
                        CloneNameRef.current.style = 'border: solid red 2px'
                        return false
                    }
                    cloneToDoListItem(
                        group.id,
                        list.resource.id,
                        CloneNameRef.current.value
                    )
                        .then(res => { return true })
                        .catch(err => showError(err))
                }
            }
            ,
            title: () => { },
            heading: "Clone : New Name",
            children: <div>
                <p>Please enter a name for the new item</p>
                <input
                    ref={CloneNameRef}
                    className='form-control' placeholder='New name' />
                <b>Or</b>
                <textarea ref={CloneBulkRef} className='form-control' rows={10} placeholder='Enter a list of items to clone in bulk separated by a new line for each item'>

                </textarea>
            </div>,
            // type: () => { },
            options: {
                cancel: 'Cancel',
                confirm: 'Clone'
            }
        })
    }


    return (<>
        <div className='lists-container'>
            <TitleBarComponent
                cloneable={{
                    action: _handleClone
                }}
                reference='FacilityToDoListNewListItemItem'
                onEdit={onEdit}
                onRemove={onRemove}
                container={list.resource.list}
                title={list.resource.list}
            />
            {children}
        </div>
    </>)
}
